import useTermsAndConditions from '@map/components/MobileTermsAndConditions/useTermsAndConditions';
import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import { useFormatMessage } from '@shared/hooks/intl';
import Link from '@ui/Link';

const useStyles = makeStyles(({ palette, spacing }) => ({
  disclaimer: {
    paddingTop: spacing(6),
    color: palette.neutrals[800],
    '&&': {
      marginTop: 'auto',
    },
    '& a': {
      cursor: 'pointer',
      color: palette.neutrals[800],
      fontWeight: 700,
    },
  },
}));

const TermsAppendix: FC = () => {
  const { classes } = useStyles();
  const [show, node] = useTermsAndConditions();
  const t = useFormatMessage();

  return (
    <>
      {node}
      <Typography variant="body2" align="center" className={classes.disclaimer}>
        {t('registration.disclaimer', {
          terms: (
            <Link variant="inherit" onClick={() => show('termsOfUse')} key="1">
              {t('registration.terms_and_conditions')}
            </Link>
          ),
          policy: (
            <Link variant="inherit" onClick={() => show('privacyPolicy')} key="2">
              {t('registration.privacy_policy')}
            </Link>
          ),
        })}
      </Typography>
    </>
  );
};

export default TermsAppendix;
